/**
 * "Kvalita korpusu" is for NK staff only (CZNA-1440, decided 22. 10. 2026). mod-czna-users
 * grants this read to accounts of NK and to the authority admin; the rail, the dashboard
 * tile and the route follow it. `hasPerm` is UX only — the backend answers 403 either way.
 */
export var CORPUS_QUALITY_CAPABILITY = 'czna-authorities.validation.quality.read';
